import { StyledSvg } from "baseui/icon";
import React from "react";

export const VisaIcon = (props: React.ComponentProps<typeof StyledSvg>) => {
  return (
    <StyledSvg viewBox="0 0 100 100" fill="none" {...props}>
      <path
        d="M93.75 72.9167C93.75 77.5187 90.0187 81.25 85.4167 81.25H14.5833C9.98125 81.25 6.25 77.5187 6.25 72.9167V27.0833C6.25 22.4812 9.98125 18.75 14.5833 18.75H85.4167C90.0187 18.75 93.75 22.4812 93.75 27.0833V72.9167Z"
        fill="#1565C0"
      />
      <path
        d="M31.637 39.5841L26.1662 55.9008C26.1662 55.9008 24.7766 48.9987 24.6391 48.132C21.5245 41.0258 16.9287 41.4216 16.9287 41.4216L22.3454 62.5008V62.4966H28.9308L38.037 39.5841H31.637ZM36.8516 62.5008H42.8329L46.4495 39.5841H40.3933L36.8516 62.5008ZM79.1829 39.5841H72.8891L63.0766 62.5008H69.0183L70.2433 59.2279H77.735L78.3725 62.5008H83.8162L79.1829 39.5841ZM71.9016 54.8508L75.1579 46.1904L76.862 54.8508H71.9016ZM54.935 46.2633C54.935 45.0008 55.9725 44.0612 58.9475 44.0612C60.8808 44.0612 63.0954 45.4654 63.0954 45.4654L64.0662 40.6549C64.0662 40.6549 61.237 39.582 58.46 39.582C52.1704 39.582 48.9266 42.5904 48.9266 46.3987C48.9266 53.2862 57.2162 52.3424 57.2162 55.8799C57.2162 56.4862 56.735 57.8883 53.2829 57.8883C49.8204 57.8883 47.535 56.6195 47.535 56.6195L46.5037 61.2362C46.5037 61.2362 48.7183 62.4987 52.9975 62.4987C57.287 62.4987 63.237 59.2904 63.237 54.682C63.237 49.1383 54.935 48.7383 54.935 46.2633Z"
        fill="white"
      />
      <path
        d="M25.4419 51.969L23.4294 42.0773C23.4294 42.0773 22.519 39.9336 20.1523 39.9336C17.7857 39.9336 10.9023 39.9336 10.9023 39.9336C10.9023 39.9336 22.6961 43.4169 25.4419 51.969Z"
        fill="#FFC107"
      />
    </StyledSvg>
  );
};
